import React from "react";
import "./ContactUsPageStyle.scss";
import MainLayout from "../../components/MainLayout";
import ContactUsSection from "../../components/ContactUsSection";

const ContactUsPage = () => {
  return (
    <MainLayout>
      <div className="contact-us-page">
        <ContactUsSection />
      </div>
    </MainLayout>
  );
};

export default ContactUsPage;
